import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

import Logo from "../Logo";

const NavIcon = () => {
  return (
    <>
        <Link to="/portal">
          <Logo height="40" />
        </Link>
        <Link to="/portal" style={{ textDecoration: 'none' }}>
          <Typography
            color="white"
            variant="h6"
            sx={{
              ml: 2,
            }}
          >
            myNSSC
          </Typography>
        </Link>
    </>
  );
};

export default NavIcon;
